import { getNextVisibleSection } from "../../../questionnaire/utils/getVisibleSection";
import type { QuestionnaireState } from "../../types";

export const handleNextSectionAction = (
  state: QuestionnaireState,
): QuestionnaireState => {
  const { sections, lastViewedSectionIndex } = state;
  const nextSectionIndex = getNextVisibleSection(state);
  const updatedSections = sections.map((section, index) =>
    index < nextSectionIndex ? { ...section, isVisited: true } : section,
  );

  const updatedLastViewedSectionIndex = Math.max(
    nextSectionIndex,
    lastViewedSectionIndex,
  );

  return {
    ...state,
    currentSectionIndex: nextSectionIndex,
    lastViewedSectionIndex: updatedLastViewedSectionIndex,
    sections: updatedSections,
    isValid: false,
  };
};
